import react, { useState, useEffect } from "react";
import HandshakeIcon from "@mui/icons-material/Handshake";
import BlockIcon from "@mui/icons-material/Block";
import MenuEmpresas from "./menuempresas";
import Box from "@mui/joy/Box";
import Card from "@mui/joy/Card";
import CardOverflow from "@mui/joy/CardOverflow";
import CardCover from "@mui/joy/CardCover";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import CardContent from "@mui/joy/CardContent";
import IconButton from "@mui/joy/IconButton";
import Grid from "@mui/joy/Grid";
import Button from "@mui/joy/Button";
import axios from "axios";
import PublicIcon from "@mui/icons-material/Public";
import ScheduleIcon from "@mui/icons-material/Schedule";
import Table from "@mui/joy/Table";
import ButtonGroup from "@mui/joy/ButtonGroup";
import { useNavigate } from "react-router-dom";

export default function AventurasPublicadas() {
  let [aventuras, setAventuras] = react.useState();
  let [cuenta, setCuenta] = react.useState();
  let navigate = useNavigate();

  useEffect(() => {
    let getInformacion = async () => {
      try {
        let token = localStorage.getItem("token");
        let getAventuras = await axios.get(
          `${process.env.REACT_APP_FRONTEND_URL}/api/escritorio/mis-aventuras`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAventuras(getAventuras.data.aventuras);
        setCuenta(getAventuras.data.cuenta);
      } catch (err) {
        console.log(
          "Tenemos un errro al obtener las aventuras de la cuenta: " + err
        );
      }
    };
    getInformacion();
    console.log("hola");
  }, []);

  let Tabla = ({ listaAventuras }) => {
    return (
      <Box
        sx={{
          width: "70vw",
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 5,
        }}
      >
        <Table variant="plain" color="neutral">
          <thead>
            <tr>
              <th>Titulo</th>
              <th>Precio</th>
              <th>Estado</th>
              <th>Fecha de Ejecución</th>
              <th>Participantes</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {listaAventuras.map((x, index) => {
              console.log("si");
              console.log(x);
              let fechaFormato = new Date(x.fecha);
              let participantes = x.participantes.filter((y) => y !== cuenta);

              return (
                <tr>
                  <td>{x.titulo}</td>
                  <td>
                    ${new Intl.NumberFormat("es-CL").format(x.precio)} CLP
                  </td>
                  <td>{x.estado}</td>
                  <td>
                    {fechaFormato.toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                      timeZone: "UTC",
                    })}
                  </td>
                  <td>{participantes.length} participantes</td>
                  <td>
                    <ButtonGroup>
                      <Button
                        size="sm"
                        color="neutral"
                        variant="soft"
                        onClick={() => {
                          navigate(
                            `/panel/escritorio/aventuras-publicadas/detalle`,
                            { state: { x } }
                          );
                        }}
                      >
                        Detalle
                      </Button>
                      <Button
                        size="sm"
                        color="neutral"
                        variant="soft"
                        onClick={() => {
                          navigate(
                            `/aventuras/${x.id_actividad}/${x.titulo}/editar`
                          );
                        }}
                      >
                        Editar
                      </Button>
                    </ButtonGroup>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Box>
    );
  };

  return (
    <Box sx={{ display: "flex", flexGrow: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          alignContent: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Box marginTop={"5rem"}>
          <Box sx={{ maxWidth: 1000 }}>
            <Typography level="title-lg">Aventuras Publicadas</Typography>
            <Typography level="body-xs" sx={{ marginTop: 1 }}>
              En esta sección se muestran todas las aventuras registradas por su
              cuenta. Podrá revisar la información publicada, visualizar cada
              aventura tal como la observa el usuario final, realizar
              modificaciones cuando corresponda, consultar el número de
              participantes inscritos y verificar el estado de cada publicación
              (en revisión, aceptada o rechazada).
            </Typography>
          </Box>

          {aventuras ? <Tabla listaAventuras={aventuras} /> : null}
        </Box>
      </Box>
      <MenuEmpresas />
    </Box>
  );
}
